import { createContext } from "react";
import { MembershipContextType } from "./types/membershipContextType";

const MembershipContext = createContext<MembershipContextType>({
  membershipStatus: null,
  updateMembershipStatus: () => {}
});

export default MembershipContext;
